var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTransferDumoBackground(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 650,
    height: 710,
    viewBox: "0 0 650 710",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3_112",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 650,
    height: 710
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M630 0H20C8.9543 0 0 8.9543 0 20V690C0 701.046 8.9543 710 20 710H630C641.046 710 650 701.046 650 690V20C650 8.9543 641.046 0 630 0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3_112)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M630 0H20C8.9543 0 0 8.9543 0 20V690C0 701.046 8.9543 710 20 710H630C641.046 710 650 701.046 650 690V20C650 8.9543 641.046 0 630 0Z",
    fill: "#F8F8FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M630 0H20C8.9543 0 0 8.9543 0 20V690C0 701.046 8.9543 710 20 710H630C641.046 710 650 701.046 650 690V20C650 8.9543 641.046 0 630 0Z",
    fill: "url(#paint0_linear_3_112)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.94,
    filter: "url(#filter0_i_3_112)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M754 150.5C754 177.788 743.223 203.972 724.015 223.355C704.806 242.737 678.72 253.75 651.433 253.996C624.146 254.242 597.866 243.702 578.311 224.669C558.756 205.635 547.509 179.65 547.017 152.366C546.525 125.082 556.828 98.708 575.684 78.982C594.54 59.2567 620.423 47.7758 647.701 47.0379C674.979 46.2999 701.445 56.3646 721.34 75.042C741.235 93.719 752.949 119.498 753.933 146.768L710.488 148.336C709.918 132.52 703.124 117.569 691.585 106.736C680.047 95.904 664.697 90.067 648.877 90.495C633.056 90.923 618.044 97.581 607.109 109.022C596.173 120.462 590.197 135.758 590.482 151.582C590.768 167.406 597.291 182.477 608.632 193.516C619.973 204.554 635.215 210.668 651.041 210.525C666.867 210.382 681.996 203.995 693.137 192.754C704.277 181.513 710.527 166.326 710.527 150.5H754Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.56,
    filter: "url(#filter1_f_3_112)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M637.888 173.477C650.69 179.943 666.309 174.808 672.776 162.007C679.242 149.205 674.107 133.586 661.306 127.119C648.504 120.653 632.885 125.788 626.418 138.589C619.952 151.391 625.087 167.01 637.888 173.477Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M660.464 119.978C677.064 125.748 686.041 143.864 680.271 160.464C674.501 177.064 656.137 185.955 639.537 180.185C622.937 174.415 614.294 156.137 620.064 139.537C625.834 122.938 643.864 114.208 660.464 119.978ZM633.842 145.438L640.556 158.879C640.954 160.128 642.689 160.731 644.024 160.084L668.398 148.284C671.737 146.668 669.226 141.907 666.221 143.362L644.098 154.278L638.764 143.26C637.147 139.921 632.387 142.432 633.842 145.437V145.438Z",
    fill: "url(#paint1_linear_3_112)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.56,
    filter: "url(#filter2_f_3_112)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.8461 242.802C70.4495 245.841 77.4554 243.762 80.4943 238.158C83.5332 232.555 81.4542 225.549 75.8509 222.51C70.2475 219.471 63.2416 221.55 60.2027 227.154C57.1638 232.757 59.2428 239.763 64.8461 242.802Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.5688 219.326C82.8688 222.105 86.6219 230.27 83.8432 237.57C81.0646 244.87 72.7909 248.582 65.4908 245.803C58.1908 243.024 54.5879 234.792 57.3665 227.492C60.1451 220.192 68.2688 216.548 75.5688 219.326ZM63.4113 230.292L66.2196 236.351C66.3805 236.911 67.1433 237.201 67.7449 236.931L78.7263 232.005C80.2307 231.33 79.1769 229.182 77.823 229.79L67.8531 234.353L65.6261 229.388C64.9512 227.884 62.8038 228.938 63.4113 230.292Z",
    fill: "url(#paint2_linear_3_112)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.46,
    filter: "url(#filter3_f_3_112)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M340.032 133.909C346.878 130.653 349.789 122.463 346.533 115.617C343.277 108.77 335.087 105.86 328.24 109.116C321.394 112.372 318.484 120.561 321.74 127.408C324.996 134.254 333.185 137.165 340.032 133.909Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M324.982 107.153C332.767 102.084 343.243 104.197 348.312 111.982C353.381 119.767 351.151 130.319 343.366 135.388C335.581 140.457 325.145 138.152 320.076 130.367C315.008 122.582 317.197 112.221 324.982 107.153ZM327.002 126.519L334.793 128.065C335.444 128.303 336.257 127.773 336.419 127.006L339.379 113.001C339.784 111.082 336.982 110.59 336.617 112.317L334.017 125.096L327.686 123.758C325.767 123.352 325.275 126.154 327.002 126.519Z",
    fill: "url(#paint3_linear_3_112)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_3_112",
    x: 547,
    y: 47,
    width: 207,
    height: 210,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.772135 0 0 0 0 0.270833 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_3_112"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_3_112",
    x: 610.276,
    y: 110.2,
    width: 79.7457,
    height: 79.7454,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "effect1_foregroundBlur_3_112"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_3_112",
    x: 48.4293,
    y: 210.395,
    width: 44.3315,
    height: 44.3315,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "effect1_foregroundBlur_3_112"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_3_112",
    x: 309.346,
    y: 96.3994,
    width: 49.684,
    height: 49.6844,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "effect1_foregroundBlur_3_112"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3_112",
    x1: 325,
    y1: 0,
    x2: 325,
    y2: 710,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDDF6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3_112",
    x1: 617.945,
    y1: 144.89,
    x2: 680.026,
    y2: 152.887,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#54B06C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#57DC79"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3_112",
    x1: 56.3557,
    y1: 229.843,
    x2: 83.8329,
    y2: 234.201,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#54B06C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#57DC79"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3_112",
    x1: 321.627,
    y1: 132.985,
    x2: 345.067,
    y2: 109.632,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#54B06C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#57DC79"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransferDumoBackground);
export default __webpack_public_path__ + "static/media/TransferDumoBackground.dfc93cd9221b1f2f574cebfcdcc682e7.svg";
export { ForwardRef as ReactComponent };